var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramFamily40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7 C5.4329975,7 7,5.43299983 7,3.5 C7,1.56700462 5.4329975,0 3.5,0 C1.5670025,0 0,1.56700462 0,3.5 C0,5.43299983 1.5670025,7 3.5,7 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.5 C0,2.91015273 2.4624325,0 5.5,0 C8.5375675,0 11,2.91015273 11,6.5 L11,13 L0,13 L0,6.5 L0,6.5 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7 C5.4329975,7 7,5.43299983 7,3.5 C7,1.56700462 5.4329975,0 3.5,0 C1.5670025,0 0,1.56700462 0,3.5 C0,5.43299983 1.5670025,7 3.5,7 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.5 C0,2.91015273 2.4624325,0 5.5,0 C8.5375675,0 11,2.91015273 11,6.5 L11,13 L0,13 L0,6.5 L0,6.5 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Couple40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.1875 -2.22168056 9.1875 -2.22168056 9.1875 9.22168056 -2.1875 9.22168056"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,7 C7.4329975,7 9,5.43299638 9,3.5 C9,1.56700318 7.4329975,0 5.5,0 C3.56700337,0 2,1.56700318 2,3.5 C2,5.43299638 3.56700337,7 5.5,7 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.29166667 -2.35770096 13.2916667 -2.35770096 13.2916667 15.3577033 -2.29166667 15.3577033"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.5 C0,9.91014943 2.46243387,7 5.5,7 C8.5375675,7 11,9.91014943 11,13.5 L11,20 L0,20 L0,13.5 L0,13.5 Z",
    id: "Stroke-8",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "-2.1875 -2.22168056 9.1875 -2.22168056 9.1875 9.22168056 -2.1875 9.22168056"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,7 C17.4329975,7 19,5.43299638 19,3.5 C19,1.56700318 17.4329975,0 15.5,0 C13.5670034,0 12,1.56700318 12,3.5 C12,5.43299638 13.5670034,7 15.5,7 Z",
    id: "Stroke-12",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFCC00",
    mask: "url(#mask-8)",
    points: "-2.29166667 -2.35770096 13.2916667 -2.35770096 13.2916667 15.3577033 -2.29166667 15.3577033"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,13.5 C10,9.91014943 12.4624339,7 15.5,7 C18.5375675,7 21,9.91014943 21,13.5 L21,20 L10,20 L10,13.5 L10,13.5 Z",
    id: "Stroke-16",
    stroke: "#4F4C4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramFamily40);
export default __webpack_public_path__ + "static/media/pictogramFamily40.756a33863cd9e4267a92547f493c4a7d.svg";
export { ForwardRef as ReactComponent };